import React from "react";
import { CarouselModal } from "@src/lms/jelly/extensions/layouts/_lesson/case7/common/components/CarouselModal";
import { useIntl } from "react-intl";
import * as appConfig from "appConfig";

import styles from "./NewSession.module.scss";
import { useUi } from "@jelly/lesson";
import { messages } from "../../Workflow.messages";

type OrganiseTracksModalProps = Omit<React.ComponentProps<typeof CarouselModal>, "children">;

export const OrganiseTracksModal: React.FC<OrganiseTracksModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  return (
    <ui.Modal {...props}>
      <div className={styles.content}>
        <div className={styles.left}>
          <h2 className={styles.title}>{formatMessage(messages.organisingTheSessionOrganiseTracksTitle)}</h2>
          <p
            className={styles.description}
            dangerouslySetInnerHTML={{ __html: formatMessage(messages.organisingTheSessionOrganiseTracksDescription) }}
          ></p>
        </div>
        <div className={styles.right}>
          <img
            className={styles.image}
            src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/workflow/9.png`}
            alt="feature-comparison"
          />
        </div>
      </div>
    </ui.Modal>
  );
};
